/** Stub for CDN bundle */
export const ExperimentationTags = { fireAdobeTags: () => Promise.resolve() };
export const Experimentation = {
  isRecipeSelected: () => Promise.resolve(false),
  getSelectedRecipesForExperiment: () => Promise.resolve([]),
};
